import { isTottusStandalone } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Button from '../../ui/Button/Button';
import { Modal } from '../../ui/Modal/Modal';
import CreateListButton from '../CreateList/CreateList';
import CreateListForm from '../CreateListForm/CreateListForm';
import List from '../List/List';
import styles from '../MyLists.style';

const MyListsModal = ({
  appCtx,
  onSaveLists,
  createList,
  toggleState,
  myLists,
  onListChange,
  validateList,
  error,
  loading,
  labels,
  formState,
  isSaveButtonEnabled,
}) => {
  const { deviceType, store } = appCtx;

  const isTottusSA = isTottusStandalone(store);
  const [modalTitle, setModalTitle] = useState('');
  const paddingModal = deviceType === 'desktop' ? '28px 27px 24px 27px' : '24px 16px 16px 16px';

  const handleCloseModal = () => {
    toggleState.setVisible(!toggleState.visible);
    formState.setVisible(false);
  };

  useEffect(() => {
    const newTitle = formState.visible ? labels.createNewList : labels.addToList;
    setModalTitle(newTitle);
  }, [formState.visible]);

  const modalContent = () => {
    return (
      <div className="my-lists-modal-container">
        <div className="my-lists-modal-header">
          <i className="csicon-my-list" />
          <span>{modalTitle}</span>
          {!formState.visible && deviceType === 'desktop' && (
            <p>Selecciona la lista a la cual deseas agregar este producto.</p>
          )}
        </div>
        {formState.visible ? (
          <CreateListForm
            validateList={validateList}
            onSubmit={createList}
            error={error}
            loading={loading}
            labels={labels}
          />
        ) : (
          <>
            <List title={labels.myLists} onListChange={onListChange} items={myLists} deviceType={deviceType} />
            <CreateListButton label={labels.createNewList} showForm={formState.setVisible} />
            <div className={`my-lists-button ${isTottusSA ? 'tottus' : ''}`}>
              <div className="box-button">
                {isTottusSA ? (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      onSaveLists();
                    }}
                    disabled={!isSaveButtonEnabled}
                    id="save-lists"
                    className="tocom-save-button"
                  >
                    {labels.save}
                  </button>
                ) : (
                  <Button
                    id="save-lists"
                    letterSpace="regular"
                    type="mkp-secondary"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      onSaveLists();
                    }}
                    disabled={!isSaveButtonEnabled}
                  >
                    {labels.save}
                  </Button>
                )}
              </div>
            </div>
          </>
        )}
        <style jsx>{styles}</style>
      </div>
    );
  };

  return (
    <Modal
      showCloseButton
      content={modalContent}
      options={{
        width: 500,
        height: 'auto',
        maxHeight: 515,
        padding: paddingModal,
        borderRadius: '5px',
      }}
      toggleState={{
        visible: toggleState.visible,
        setVisible: handleCloseModal,
      }}
      withPadding={false}
      className="bottom"
      customClassBody="auto"
      fullWidth={deviceType !== 'desktop'}
      deviceType={deviceType}
    />
  );
};

MyListsModal.propTypes = {
  appCtx: PropTypes.object.isRequired,
  onSaveLists: PropTypes.func.isRequired,
  createList: PropTypes.func.isRequired,
  onListChange: PropTypes.func.isRequired,
  validateList: PropTypes.func.isRequired,
  myLists: PropTypes.array.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  isSaveButtonEnabled: PropTypes.bool,
  toggleState: PropTypes.objectOf({
    visible: PropTypes.bool.isRequired,
    setVisible: PropTypes.func.isRequired,
  }).isRequired,
  formState: PropTypes.objectOf({
    visible: PropTypes.bool.isRequired,
    setVisible: PropTypes.func.isRequired,
  }).isRequired,
  labels: PropTypes.objectOf({
    save: PropTypes.string,
    myLists: PropTypes.string,
    inputNewListName: PropTypes.string,
    addToAlist: PropTypes.string,
    createNewList: PropTypes.string,
    addToList: PropTypes.string,
  }),
};
MyListsModal.defaultProps = {
  error: '',
  loading: false,
  labels: {},
  isSaveButtonEnabled: true,
};
export default MyListsModal;
